module.exports = __webpack_public_path__ + "media/images/new/icons/payoo-669bce48a15f58863ae4482ad2125ad4.png";